export class FormatUtil {
  static nextLineBreaker(text: string, index: number): string {
    if (text.length > index) {
      return text.replace(new RegExp(`(.{${index}})`, 'g'), '$1<br>');
    } else {
      return text;
    }
  }
}
